var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"related-products"},[_c('ProductCarousel',{staticClass:"related-products-carousel",attrs:{"title":"Goes well with","products":_vm.relatedProducts},on:{"productClicked":_vm.onProductClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }